"use client";

import { type ReactNode, useEffect } from "react";
import { trackSeoEvent, seoAnalyticsAllowed } from "@/lib/seo-events";

export function ContentHubView({
  article = "hub",
  pagePath = "/small-business-101",
}: {
  article?: string;
  pagePath?: string;
}) {
  useEffect(() => {
    let sent = false;
    const send = () => {
      if (!sent && seoAnalyticsAllowed()) {
        trackSeoEvent("small_business_101_view", { article, page_path: pagePath });
        sent = true;
      }
    };
    send();
    const timer = window.setInterval(() => { send(); if (sent) window.clearInterval(timer); }, 1000);
    return () => window.clearInterval(timer);
  }, [article, pagePath]);

  return null;
}

export function FreeCheckCta({
  article = "hub",
  children,
  className,
  location,
}: {
  article?: string;
  children: ReactNode;
  className: string;
  location: string;
}) {
  return (
    <a
      href="/#free-glow-check"
      onClick={() =>
        trackSeoEvent("small_business_101_cta_click", {
          article,
          link_location: location,
        })
      }
      className={className}
    >
      {children}
    </a>
  );
}
